import {
  OMNIBAR_SUPPORTED_ROUTES,
  OMNIBAR_SUPPORTED_ROUTE_WITH_UI_DIALOG,
  OMNIBAR_SUPPORTED_SEARCH_PARAMS,
  OMNIBAR_SUPPORTED_TABS,
} from 'Modules/Shared/constants';
import { location as getLocation } from 'Modules/Shared/selectors/location';
import { getLdClient } from 'Utils/ldClient';

export const omnibarOpen = state => state.getIn(['omnibar', 'omnibarOpen']);

/**
 * Determines whether to show Omnibar based on the route/tab, URL params,
 * or even the UI state
 * @returns {boolean}
 */
export const shouldShowOmnibar = state => {
  const location = getLocation(state);
  if (!location) return false;

  return (
    isSupportedRoute(location) ||
    isSupportedTab(location) ||
    isSupportedRouteWithSearchParam(location) ||
    isSupportedRouteWithUIPath(location, state)
  );
};

const isSupportedRoute = location => {
  const routeName = location.get('routeName');
  return OMNIBAR_SUPPORTED_ROUTES.includes(routeName);
};

const isSupportedTab = location => {
  const routeName = location.get('routeName');
  const tabName = location.getIn(['routeParams', 'tabName']);

  return OMNIBAR_SUPPORTED_TABS.some(
    route => route.tabName === tabName && route.routeName === routeName
  );
};

const isSupportedRouteWithSearchParam = location => {
  const routeName = location.get('routeName');

  return OMNIBAR_SUPPORTED_SEARCH_PARAMS.some(
    route =>
      route.routeName === routeName &&
      location.get('searchParams').get(route.searchParam) ===
        route.supportedValue &&
      checkIfRouteFFEnabled(route.featureFlag)
  );
};

const isSupportedRouteWithUIPath = (location, state) => {
  const routeName = location.get('routeName');

  return OMNIBAR_SUPPORTED_ROUTE_WITH_UI_DIALOG.some(
    routeWithDialog =>
      routeWithDialog.routeName === routeName &&
      state.getIn(routeWithDialog.uiDialog.path) ===
        routeWithDialog.uiDialog.expectedValue &&
      checkIfRouteFFEnabled(routeWithDialog.featureFlag)
  );
};

/**
 * If a feature flag is passed in, return a boolean
 * indicating if it is enabled
 *
 * Defaults to true since many previous routes do NOT
 * have a FF restriction
 */
const checkIfRouteFFEnabled = featureFlag => {
  if (!featureFlag) return true;
  const ldClient = getLdClient();

  return !!ldClient?.variation(featureFlag);
};

export const getActiveAccountSfdcId = state =>
  state.getIn(['omnibar', 'activeAccountSfdcId']);
